import { useEffect } from 'react'

const useOnMount = fn => {
  useEffect(() => {
    fn()
  }, []) // eslint-disable-line
}

export default useOnMount
